const { makeVar } = require("@apollo/client");

const snackbarVar = makeVar(null);

export default snackbarVar;
